import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import ReactivateContractFormService from '../services/ReactivateContractFormService';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import UpfrontContractProductsList from './UpfrontContractProductsList';

class ReactivateContractProductsListContainer extends React.Component {
  render() {
    const contractType = ReactivateContractFormService.form.getValue('type') || toJS(ReactivateContractFormService.contract.type);
    const currencyType =
      !ReactivateContractFormService.form.getValue('country') ||
      BRAZIL.includes(ReactivateContractFormService.form.getValue('country'))
        ? 'real'
        : 'dollar';

    if (contractType === 'UPFRONT') {
      return (
        <UpfrontContractProductsList
          disabled={ReactivateContractFormService.fetch.fetching || ReactivateContractFormService.submit.fetching}
          onDelete={ReactivateContractFormService.productsService.handleDelete}
          onEdit={ReactivateContractFormService.productsService.handleEdit}
          data={toJS(ReactivateContractFormService.productsService.contractProducts)}
          loading={ReactivateContractFormService.fetch.fetching}
          submitting={ReactivateContractFormService.submit.fetching}
          currencyType={currencyType}
          onToggleProduct={ReactivateContractFormService.productsService.handleToggleProduct}
        />
      );
    }

    return (
      <PostPaymentContractProductsList
        disabled={ReactivateContractFormService.fetch.fetching || ReactivateContractFormService.submit.fetching}
        onDelete={ReactivateContractFormService.productsService.handleDelete}
        onEdit={ReactivateContractFormService.productsService.handleEdit}
        data={toJS(ReactivateContractFormService.productsService.contractProducts)}
        loading={ReactivateContractFormService.fetch.fetching}
        submitting={ReactivateContractFormService.submit.fetching}
        currencyType={
          !ReactivateContractFormService.contract.country ||
          BRAZIL.includes(ReactivateContractFormService.contract.country)
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(ReactivateContractProductsListContainer);
